import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'GET_TIN_MANAGEMENT_API';

export const useFetchTinApi = () => {
  const result = useSelector((state) => state[ACTION_TYPE]);

  const action = useAction((args) => {
    const eapm = window.elasticApm;
    let dtrumActionId;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: false,
      });
    }
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('APIM_STARGATE_URL')}${config('TIN_MANAGEMENT_API')}?q=${ACTION_TYPE}`);
      fetch(`${config('APIM_STARGATE_URL')}${config('TIN_MANAGEMENT_API')}`, {
        withCredentials: 'include',
      })
        .then((res) => {
          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('TIN_MANAGEMENT_API'),
              userInfo: args?.userInfo,
              method: 'GET',
              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,

              // result: hasReportCode ? 'success' : 'error',
            },
          });
          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('FEEDBACK_URL'),
            status: 0,
            message: 'Success',
            url: window.location.href,
            result: 'success',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });

          let transaction;
          if (eapm) {
            transaction = eapm.getCurrentTransaction();
          }
          if (transaction) {
            transaction.end();
          }
          if (res.status !== 200) {
            throw new Error('Failure');
          } else {
            return res.json();
          }
        })
        .then((res) => {
          dispatch({
            type: `${ACTION_TYPE}_COMPLETED`,
            payload: res,
          });
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('TIN_MANAGEMENT_API'),
              userInfo: args?.userInfo,
              method: 'GET',
              operationName: ACTION_TYPE,
              // code: res.status,
              // message: res.statusText,
            },
          });

          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('TIN_MANAGEMENT_API'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
          let transaction;
          if (eapm) {
            transaction = eapm.getCurrentTransaction();
          }
          if (transaction) {
            transaction.end();
          }
        });
    };
  });

  return [result, action];
};
